export default __webpack_public_path__ + "static/media/vaccination_low.49704c4b.svg";